export default "__VITE_PUBLIC_ASSET__3fea7c7d__"